import { render, staticRenderFns } from "./FontAwesome.vue?vue&type=template&id=6997afe1&"
import script from "./FontAwesome.vue?vue&type=script&lang=ts&"
export * from "./FontAwesome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6997afe1')) {
      api.createRecord('6997afe1', component.options)
    } else {
      api.reload('6997afe1', component.options)
    }
    module.hot.accept("./FontAwesome.vue?vue&type=template&id=6997afe1&", function () {
      api.rerender('6997afe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/FontAwesome.vue"
export default component.exports